import React, { useState } from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import GridContainer from 'components/Grid/GridContainer';
import { decode } from 'utils/crypto/crypto';
import NumberSettingsCard from 'components/Card/NumberSettingsCard';
import GridItem from 'components/Grid/GridItem';
import Router from '@material-ui/icons/Router';
import ResetAdslPasswordDialog from './subcomponents/ResetAdslPasswordDialog';
import { TagManager } from 'commons/gtm/tagManager';
import { getLanguage } from 'utils/language/language';
import { upIdSelector, userIdSelector } from 'redux/modules/session/selectors';
import { useSelector } from 'react-redux';

interface ISettingsProps {
	match: {
		path: string;
		params: {
			phoneNumberEncoded: string;
			upAccountId: string;
			accountNumber: string;
		};
	};
	accountName: string;
	adslLogin: string;
}

const Settings = ({ match, accountName, adslLogin }: ISettingsProps) => {
	const { phoneNumberEncoded } = match.params;
	const phoneNumber: string = decode(phoneNumberEncoded);
	const [showDialog, setShowDialog] = useState<'resetAdslPassword' | 'changeAdslPassword' | null>(null);

	// const changeAdslPassword = () => {
	// 	setShowDialog('changeAdslPassword');
	// };

	const accId = useSelector(upIdSelector);
	const userId = useSelector(userIdSelector);

	const resetAdslPassword = () => {
		setShowDialog('resetAdslPassword');
	};

	const hideDialog = () => {
		setShowDialog(null);
	};

	React.useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'My Services',
				step: `My Numbers: Settings`,
				accountID: accId,
				billingID: match.params.accountNumber,
				accountNumber: phoneNumber,
				userId: userId,
				language: getLanguage(),
			},
		});
	}, []);

	return (
		<GridContainer justify="flex-start">
			<BreadcrumbsItem to={match.path}>{`${phoneNumber} (${accountName}) - ${translate(
				'path.sim.management'
			)}`}</BreadcrumbsItem>
			{/* Change adsl password was using different service than reset, so client decided to remove it from
			<GridItem xs={12} lg={4}>
				<NumberSettingsCard
					text={translate('number.settings.change.adsl.password')}
					image={<Router />}
					onClick={changeAdslPassword}
				/>
				<ChangeAdslPasswordDialog
					isOpen={showDialog === 'changeAdslPassword'}
					hideDialog={hideDialog}
					adslLogin={adslLogin}
				/>
			</GridItem> */}
			<GridItem xs={12} lg={4}>
				<NumberSettingsCard
					text={translate('number.settings.reset.adsl.password')}
					image={<Router />}
					onClick={resetAdslPassword}
				/>
				<ResetAdslPasswordDialog
					isOpen={showDialog === 'resetAdslPassword'}
					hideDialog={hideDialog}
					adslLogin={adslLogin}
					phoneNumber={phoneNumber}
				/>
			</GridItem>
		</GridContainer>
	);
};

export default Settings;
